module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "container"
    }
  }, [_c('component-header'), _vm._v(" "), _c('section', {
    attrs: {
      "id": "main-content"
    }
  }, [(_vm.panelFlag) ? _c('section', {
    staticClass: "wrapper"
  }, [(_vm.viewFlag) ? _c('div', [_c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.contract.contract_ref))])]), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Contractor's ID "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_contractor_id))])]), _vm._v(" "), _c('li', [_vm._v("Contractor's Name "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_contractor_name))])]), _vm._v(" "), _c('li', [_vm._v("CNpro's ID "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_cnpro_id))])]), _vm._v(" "), _c('li', [_vm._v("CNpro's Name "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_cnpro_name))])]), _vm._v(" "), _c('li', [_vm._v("Contract Status "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_status))])]), _vm._v(" "), _c('li', [_vm._v("Labour Cost "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.contract.contract_labour_cost))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n                             Contract Quote Details\r\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n                                \"paging\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"filtering\": {\r\n                                \"enabled\": true\r\n                                },\r\n                                \"sorting\": {\r\n                                \"enabled\": true\r\n                                }}"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Quote Description")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contract.contract_quote_description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Material Details")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contract.contract_material_details))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Labour Cost")]), _vm._v(" "), _c('td', [_vm._v("₦" + _vm._s(_vm.contract.contract_labour_cost))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Work Duration")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.contract.contract_work_duration) + " Day(s)")])]), _vm._v(" "), _vm._m(0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('p', [_c('b', [_vm._v("Discussion: ")]), _vm._v(" "), (_vm.contract.contract_contract_threads) ? _c('span', [_vm._v("(" + _vm._s(_vm.contract.contract_contract_threads.length) + ") Message(s)")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewDiscussion', '')
      }
    }
  }, [_vm._v("View Discussion")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_c('p', [_c('b', [_vm._v("Complaints: ")]), (_vm.contract.contract_contract_complaints) ? _c('span', [_vm._v("(" + _vm._s(_vm.contract.contract_contract_complaints.length) + ") Complaint(s)")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setPanel('viewComplaints', '')
      }
    }
  }, [_vm._v("View Complaints")])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 stats-info widget"
  }, [_c('div', {
    staticClass: "stats-info-agileits"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "stats-body"
  }, [_vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.contract.contract_status_id != 12) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.endContract
    }
  }, [_vm._v("End Contract")]) : _vm._e(), _vm._v(" "), (_vm.contract.contract_status_id == 12) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#ff0000"
    }
  }, [_vm._v("Ended By \r\n                                            "), (_vm.contract.contract_closed_by != 0) ? _c('span', [_c('u', [_vm._v("Contractor")])]) : _c('span', [_c('u', [_vm._v("Admin")])])]), _vm._v(" "), _c('br')]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.viewDiscussion) ? _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Discussions\r\n                            "), _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('view', _vm.contract.contract_id)
      }
    }
  }, [_vm._v("Back to Contract")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.contract.contract_contract_threads), function(thread) {
    return _c('div', {
      staticClass: "alert alert-success clearfix"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(thread.contract_thread_user_name))])]), _vm._v(" " + _vm._s(thread.contract_thread_thread))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                         " + _vm._s(thread.contract_thread_thread_date) + "\r\n                                      ")])])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.viewComplaints) ? _c('div', {
    staticClass: "agileits-w3layouts-stats"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 stats-info stats-last widget-shadow"
  }, [_c('div', {
    staticClass: "notifications"
  }, [_c('header', {
    staticClass: "panel-heading"
  }, [_vm._v("Job Complaints\r\n                        "), _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.setPanel('view', _vm.contract.contract_id)
      }
    }
  }, [_vm._v("Back to Contract")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "notify-w3ls"
  }, _vm._l((_vm.contract.contract_contract_complaints), function(complaint) {
    return _c('div', {
      staticClass: "alert alert-danger clearfix"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "notification-info"
    }, [_c('ul', {
      staticClass: "clearfix notification-meta"
    }, [_c('li', {
      staticClass: "pull-left notification-sender"
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(complaint.contract_complaint_user_name))])]), _vm._v(" " + _vm._s(complaint.contract_complaint))])]), _vm._v(" "), _c('p', [_vm._v("\r\n                                     " + _vm._s(complaint.contract_complaint_date) + " | " + _vm._s(complaint.contract_complaint_status_name) + "\r\n                                  ")])])])
  }))])])]) : _vm._e()]) : _c('section', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "market-updates"
  }, [_c('div', {
    staticClass: "col-md-3 market-update-gd"
  }, [_c('div', {
    staticClass: "market-update-block clr-block-2"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 market-update-left"
  }, [_c('h4', [_vm._v("contracts")]), _vm._v(" "), (_vm.contracts) ? _c('h3', [_vm._v(_vm._s(_vm.contracts.length))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("@ count Today")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-agile-info"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\r\n         contracts Lists\r\n        ")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table",
    attrs: {
      "ui-jq": "footable",
      "ui-options": "{\r\n            \"paging\": {\r\n              \"enabled\": true\r\n            },\r\n            \"filtering\": {\r\n              \"enabled\": true\r\n            },\r\n            \"sorting\": {\r\n              \"enabled\": true\r\n            }}"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.contracts), function(contract, index) {
    return _c('tr', {
      attrs: {
        "data-expanded": "true"
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_ref))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_contractor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_cnpro_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contract.contract_status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          _vm.setPanel('view', contract.contract_id)
        }
      }
    }, [_vm._v("View")])])])
  }))])])])])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('td', [_vm._v("  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Contract Activity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-title"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("End Contract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("If all Contract staus are met and issues resolved. Admin can decide to end an "), _c('b', [_vm._v("Open")]), _vm._v(" Contract")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "alert-icon"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "alert-icon"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 market-update-right"
  }, [_c('i', {
    staticClass: "fa fa-contracts"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Contract ID")]), _vm._v(" "), _c('th', [_vm._v("Contractor")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs"
    }
  }, [_vm._v("CNpro")]), _vm._v(" "), _c('th', {
    attrs: {
      "data-breakpoints": "xs sm md",
      "data-title": "DOB"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("~")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60ee74ff"}!./src/components/Contracts/template.html
// module id = 161
// module chunks = 0